// extracted by mini-css-extract-plugin
module.exports = {"centerImage":"CenterImage-CenterImage-centerImage-3e05f3df"};